import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';
import type { PositionalArgs } from 'ember-modifier';

interface StopPropagationSignature<Args extends unknown[] = unknown[], Ret = void> {
  Args: {
    Positional: [handler?: (event: Event, ...rest: Args) => Ret];
  };
  Return: (event: Event) => Ret;
}

export function stopPropagation<Args extends unknown[] = unknown[], Ret = void>(
  [handler]: PositionalArgs<StopPropagationSignature<Args, Ret>>,
  _named: {}
) {
  assert(
    `Expected '${handler}' to be a function, if present.`,
    !handler || typeof handler === 'function'
  );

  return function (event: Event, ...rest: Args) {
    assert(
      `Expected '${event}' to be an Event and have a 'stopPropagation' method.`,
      event && typeof event.stopPropagation === 'function'
    );

    event.stopPropagation();

    if (handler) handler(event, ...rest);
  };
}

const stopPropagationHelper = helper<StopPropagationSignature>(stopPropagation);
export default stopPropagationHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'stop-propagation': typeof stopPropagationHelper;
  }
}
